import { RootState } from 'app/store/store';

export const getGameRounds = (state: RootState) => state.gameRounds.roundsStates;

export const getRoundPhaseStatus = (state: RootState) => state.gameRounds.roundPhaseStatus;
